<template>
  <span v-if="model.value" v-tooltip="valueTooltip">
    {{ truncateWithEllipsis(model.value?.toString() || "", 40) }}
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { truncateWithEllipsis } from "@/helpers/formatting";

import type { ScorecardGroupCategoryForPreview } from "@/models/scorecards";
import type { PropType } from "vue";

const props = defineProps({
  model: {
    type: Object as PropType<ScorecardGroupCategoryForPreview>,
    required: true,
  },
});

const valueTooltip = computed(() => ({
  content: props.model.value?.toString(),
  onShow: () => (props.model.value?.toString()?.length || 0) > 15,
}));
</script>
